export default {"src":"/_next/static/media/Twitter.80f56d15.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};